import EmberRouter from '@ember/routing/router';
import config from 'bullitt-time-cloud-live/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('login');
  this.route('event', { path: '/event/:event_uuid' }, function () {
    this.route('classgroup', { path: '/classgroup/:classgroup_uuid' });
    this.route('timingpoint', { path: '/timingpoint/:timingpoint_uuid' });
    this.route('watchlist');
  });
});
